import actions from './actions';
import { all, takeEvery, call, put, select } from 'redux-saga/effects';
import { fetchAllEventTypes } from '../../../api/deviceEvents/deviceEvents.api';
import notifications from '../notification/actions';
import {getDeviceType} from "../deviceVersion/selectors";


export function* fetchEventTypes(payload) {
    try{
        const isKarieDUO = yield select(getDeviceType);
        const params = {
            ...payload.search,
            isKarieDUO}
        const response = yield call(fetchAllEventTypes, params ? params : {});
        if(response.eventsList){
            yield put({
                type: actions.FETCH_EVENT_TYPES_SUCCESS,
                events: response.eventsList
            });
        }else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_EVENT_TYPES_ERROR
            }));
        }
    }catch(error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_EVENT_TYPES_ERROR
        }))
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.FETCH_EVENT_TYPES, fetchEventTypes),
    ]);
}
